import colorConfig from "./color-config.json";

const COLOR_ENTRIES = colorConfig.colors;
const PRIMARY_PALETTES = colorConfig.palettes || {};

const resolveValue = (compConfig, entry) => {
  const direct = compConfig[entry.configKey];
  if (direct != null) return direct;
  if (entry.fallbackConfigKey) {
    const fallback = compConfig[entry.fallbackConfigKey];
    if (fallback != null) return fallback;
  }
  return null;
};

const setVar = (style, cssVar, value) => {
  if (value != null) style[cssVar] = value;
};

const paletteToStyle = (palette) => {
  if (!palette) return {};
  const style = {};
  setVar(style, "--theme-primary", palette.colorPrimary);
  setVar(style, "--theme-highlight", palette.colorSecondary);
  setVar(style, "--theme-on-primary", palette.colorOnPrimary);
  setVar(style, "--theme-primary-hover", palette.colorPrimaryHover || palette.colorSecondary);
  if (palette.colorPrimary) {
    setVar(style, "--theme-glow", `color-mix(in srgb, ${palette.colorPrimary} 25%, transparent)`);
  }
  return style;
};

const resolvePalette = (compConfig) => {
  const key = String(compConfig?.primaryPalette || "").trim().toLowerCase();
  return PRIMARY_PALETTES[key] || null;
};

export const buildThemeConfig = (compConfig, hasDataConfig) => {
  const style = {};

  if (hasDataConfig) {
    for (const entry of COLOR_ENTRIES) {
      if (entry.derived) continue;
      const value = resolveValue(compConfig, entry);
      if (value == null) continue;
      setVar(style, entry.cssVar, value);
      if (entry.extraCssVars) {
        for (const extra of entry.extraCssVars) setVar(style, extra, value);
      }
    }

    const primary = compConfig.colorPrimary;
    const highlight = compConfig.colorSecondary;
    const onPrimary = compConfig.colorOnPrimary;

    if (compConfig.colorPrimaryHover == null && highlight != null) {
      setVar(style, "--theme-primary-hover", highlight);
    }
    if (compConfig.colorGlow == null && primary != null) {
      setVar(style, "--theme-glow", `color-mix(in srgb, ${primary} 25%, transparent)`);
    }
    if (compConfig.colorOnCta == null && onPrimary != null) {
      setVar(style, "--theme-on-cta", onPrimary);
    }
  }

  Object.assign(style, paletteToStyle(resolvePalette(compConfig)));
  return style;
};

export { colorConfig, PRIMARY_PALETTES };
